module.exports = __webpack_public_path__ + "img/parter-work10.9483b475.png";